import React, { useState } from "react";
import {Button, FlexContainer, LabelText, Input} from "../../../../design";
import { InfoCircleFilled } from "@ant-design/icons";
import CancelConfirmationModal from "../CancelConfirmationModal";

type Props = {
  pauseSubscription: Function,
  cancelSubscription: Function,
  resumeSubscription: Function,
  subscription: Object,
}

const ManageSubscription = (props: Props) => {

    const {
      pauseSubscription,
      cancelSubscription,
      resumeSubscription,
      subscription,
    } = props;

    const [pauseInterval, setPauseInterval] = useState(null);
    const [showInterval, setShowInterval] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const confirmCancel = () => {
      setShowConfirmationModal(false);
      cancelSubscription();
    };

  return (
    <>
      <div className="px-4">
        <LabelText
          marginTop="30px"
          marginBottom="10px"
        >
          Manage Subscription
        </LabelText>
      </div>
      <hr className="my-2"/>
      <FlexContainer paddingLeft="1.5rem" display="block" marginTop="0.7rem">
        
        {
            subscription?.status === 'PAUSED' ? (
                <Button style={{transition: 'opacity 1.15s linear'}} type="secondary" borderRadius="50px" border="1px solid #EEBB22 !important" className="px-3 py-2 mt-3" onClick={() => resumeSubscription(true)} >Resume</Button>
            ) : (
                <Button style={{transition: 'opacity 1.15s linear'}} type="secondary" borderRadius="50px" border="1px solid #EEBB22 !important" className="px-3 py-2 mt-3" onClick={() => setShowInterval(true)} >Pause</Button>
            )
        }
        <Button style={{transition: 'opacity 1.15s linear', marginLeft: '15px'}} type="secondary" borderRadius="50px" border="1px solid #FF4D50 !important" className="px-3 py-2 mt-3" onClick={() => setShowConfirmationModal(true)} >Cancel</Button>
        {subscription?.status === 'PAUSED' && subscription?.subscriptionChargeType === 'CHARGE' ? (
          <p style={{ fontSize: '12px', color: '#898585', lineHeight: 'normal', marginTop: '20px' }}><InfoCircleFilled style={{ fontSize: '15px', marginRight: '5px' }} />By resuming your subscription manually during an ongoing billing cycle. you will be changed for the full billing cycle and it will be applied at the time of resumption.</p>
        ) : subscription?.status === 'PAUSED' && subscription?.subscriptionChargeType === 'PRORATE' ? (
          <p style={{ fontSize: '12px', color: '#898585', lineHeight: 'normal', marginTop: '20px' }}><InfoCircleFilled style={{ fontSize: '15px', marginRight: '5px' }} />By resuming your subscription manually during an ongoing billing cycle. you will be changed for the remaining days in that cycle and it will be applied in the next billing cycle.</p>
        ) : ""
        }
        {
            showInterval ? (
                <div>
                  {subscription?.subscriptionChargeType === 'CHARGE' ? (
                    <p style={{ fontSize: '12px', color: '#898585', lineHeight: 'normal', marginTop: '20px' }}><InfoCircleFilled style={{ fontSize: '15px', marginRight: '5px' }} />By resuming your subscription manually during an ongoing billing cycle. you will be changed for the full billing cycle and it will be applied at the time of resumption.</p>
                  ) : subscription?.subscriptionChargeType === 'PRORATE' ? (
                    <p style={{ fontSize: '12px', color: '#898585', lineHeight: 'normal', marginTop: '20px' }}><InfoCircleFilled style={{ fontSize: '15px', marginRight: '5px' }} />By resuming your subscription manually during an ongoing billing cycle. you will be changed for the remaining days in that cycle and it will be applied in the next billing cycle.</p>
                  ) : ""
                  }
                  <LabelText className="mb-1">
                      Pause Interval
                  </LabelText>
                  <Input
                      placeholder={subscription?.plan2BillingFrequency}
                      value={pauseInterval}
                      onKeyPress={e => {
                          const keyCode = e.charCode || e.which;
                          if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                              e.preventDefault();
                          }
                          if (keyCode === 48 && (!pauseInterval || pauseInterval === "0")) {
                              e.preventDefault();
                          }
                      }}
                      style={{
                          width: '100px',
                          height: '36px',
                          border: '1px solid #C4C4C4',
                          borderRadius: '6px',
                          marginRight: '5px'
                      }}
                      onChange={(e) => setPauseInterval(e.currentTarget.value)}
                  /><span style={{ fontSize: '12px', color: '#898585', marginRight: '20px' }}>{subscription?.plan2BillingFrequency}</span>
                  <Button style={{ transition: 'opacity 1.15s linear' }} type="secondary" borderRadius="50px" border="1px solid #EEBB22 !important" className="px-3 py-2 mt-3" onClick={() => { pauseSubscription(pauseInterval); setShowInterval(false); }} >Confirm</Button>
              </div>
            ) : (
                <></>
            )
        }
      </FlexContainer>
      <CancelConfirmationModal 
        open={showConfirmationModal}
        close={() => setShowConfirmationModal(false)}
        confirmCancel={confirmCancel}
      />
    </>
  )
};

export default ManageSubscription;
